
export default {
  props: {
    listName: {
      type: String,
      default: "options",
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      options: [
        {
          name: "name",
          label: "Naziv opcije",
          type: "text",
        },
        {
          name: "id",
          label: "id*",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "text",
        },
        {
          name: "image",
          label: "Ikona",
          type: "image",
        },
      ],
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    optionChanged() {
      this.$emit("option-changed");
    },
  },
};
